import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { FiSearch, FiUser, FiShoppingCart, FiLogOut } from "react-icons/fi";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { FaArrowTrendUp } from "react-icons/fa6";
import { color } from "framer-motion";
import Login from "../Login/Login";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; 
import PincodeModal from "../../PincodeModal";
import {
  IoLocationOutline,IoHeartOutline
} from "react-icons/io5";

export const Navbar3 = () => {
  const userDropdownRef = useRef(null);

  const [dropdown, setDropdown] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [navbarColor, setNavbarColor] = useState("#000");
  const [navbarTextColor, setnavbarTextColor] = useState("#ffffff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#ffffff");
  const [themeIconColor, setThemeIconColor] = useState("#ffffff");
  const [enabledropdown, setEnableDropdown] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState({});
  const [categoryCardNo, setCategoryCardNo] = useState(2);
  const accessToken = sessionStorage.getItem("accessToken");
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const navigate = useNavigate();
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const dropdownTimeout = useRef(null);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const app_logo = sessionStorage.getItem("appLogo");
  const app_name = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
   const [showModal, setShowModal] = useState(false); 
   const [wishlistCount, setWishlistCount] = useState(0);
   const [cartCount, setCartCount] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState();


  useEffect(() => {
    if (app_logo) {
      const fullUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
      const img = new Image();
      img.src = fullUrl;

      img.onload = () => setLogoAvailable(true);
      img.onerror = () => setLogoAvailable(false);
    }
  }, [app_logo]);

  useEffect(() => {
  const handleMouseMove = (e) => {
    if (
      showUserDropdown &&
      userDropdownRef.current &&
      !userDropdownRef.current.contains(e.target)
    ) {
      setShowUserDropdown(false);
    }
  };

  if (showUserDropdown) {
    document.addEventListener("mousemove", handleMouseMove);
  }

  return () => {
    document.removeEventListener("mousemove", handleMouseMove);
  };
}, [showUserDropdown]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setNavbarColor(parsedStyle.nav_bar_color);
      setnavbarTextColor(parsedStyle.navbar_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setEnableDropdown(parsedStyle.enable_navbar_dropdown === "true");
      setShowSearchBar(parsedStyle.show_search_bar === "Yes");
      setCategoryCardNo(parseInt(parsedStyle.categorycard_no));
      console.log("enabledropdown parsed:", parsedStyle.enable_navbar_dropdown);
    }

    console.log("enabledropdown state:", enabledropdown);
  }, []);

  useEffect(() => {
    fetchCategories();
  }, []);


  const fetchCategories = async () => {
    try {
      const response = await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_main_category_list",
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
        }
      );

      if (response.data.status === 1) {
        setCategories(response.data.getmain_categorylist);

        // Fetch subcategories for each main category
        response.data.getmain_categorylist.forEach((category) => {
          fetchSubCategories(category.category_auto_id);
        });
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_sub_category_list",
        {
          main_category_auto_id: categoryId,
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
        }
      );

      if (response.data.status === 1) {
        setSubCategories((prevState) => ({
          ...prevState,
          [categoryId]: response.data.getmain_subcategorylist,
        }));
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };



  const goToWallet = () => {
    !accessToken
      ? openModal()
      : navigate("/dashboard", { state: { page: "mywallet" } });
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 1) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/search_product`,
          {
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
            customer_auto_id: accessToken || admin_auto_id,
            search: value,
            limit: 15,
            page_number: 1,
          }
        );

        if (response.data.status === 1) {
          setSuggestions(response.data.get_search_products_lists || []);
          setShowDropdown(true);
        } else {
          setSuggestions([]);
          setShowDropdown(false);
        }
      } catch (error) {
        console.error("Search error:", error);
        setSuggestions([]);
        setShowDropdown(false);
      }
    } else {
      setSuggestions([]);
      setShowDropdown(false);
    }
  }; 

  const goToCart = () => {
    navigate("/cart");
  };

  const goToWishlist = () => {
    !accessToken
      ? openModal()
      : navigate("/dashboard", { state: { page: "mywishlist" } });
  }; 


    const fetchWishlistCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setWishlistCount(res.data.product_count_data);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      setWishlistCount(0);
      console.error("Error fetching wishlist count:", error);
    }
  }; 

  useEffect(() => {
    const handleUserDataUpdated = () => {
      if (accessToken) {
        fetchWishlistCount();
        fetchCartCount();
      } else {
        setWishlistCount(0); // reset when not logged in
        setCartCount(0);
      }
    };

    window.addEventListener("wishlist-updated", handleUserDataUpdated);
    window.addEventListener("cart-updated", handleUserDataUpdated);

    // Initial fetch if logged in
    if (accessToken) {
      fetchWishlistCount();
      fetchCartCount();
    }

    return () => {
      window.removeEventListener("wishlist-updated", handleUserDataUpdated);
      window.removeEventListener("cart-updated", handleUserDataUpdated);
    };
  }, [accessToken]);

  const fetchCartCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setCartCount(res.data.product_count_data);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      setCartCount(0);
      console.error("Error fetching cart count:", error);
    }
  };


  return (
    <div>
      <nav
        className={`w-full ${font}`}
        style={{ backgroundColor: navbarColor, color: navbarTextColor }}
      >
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center p-2">
          {categories.slice(-3).map((category) => (
            <div key={category.category_auto_id}>
              <Link
                to={`/maincategory/${category.category_auto_id}`}
                state={{
                  subcategoryName: "",
                  sub_cat_id: "",
                  categoryId: category.category_auto_id,
                }}
                className="text-decoration-none text-inherit text-sm p-1 font-bold"
              >
                {category.category_name}
              </Link>
            </div>
          ))}
        </div>

        <div
          className=" mx-auto flex justify-between items-center shadow-xl py-3 px-4"
          style={{ backgroundColor: themeColor }}
        >
          {/* Logo */}
          <Link to={"/"} className="text-decoration-none text-inherit">
            <div className="text-2xl font-bold cursor-pointer flex items-center space-x-2">
              {app_logo ? (
                <img
                  src={`https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`}
                  alt="App Logo"
                  className="h-10 w-auto"
                />
              ) : (
                app_name || "Grobiz"
              )}
            </div>
          </Link>

          {/* Nav Links */}

          <div className="hidden md:flex space-x-6">
            {categories.slice(0, 8).map((category) => (
              <div
                key={category.category_auto_id}
                className="relative"
                onMouseEnter={() => {
                  clearTimeout(dropdownTimeout.current);
                  setDropdown(category.category_auto_id);
                }}
                onMouseLeave={() => {
                  dropdownTimeout.current = setTimeout(() => {
                    setDropdown("");
                  }, 500);
                }}
              >
                <button
                  className="flex items-center uppercase text-sm space-x-2 text-inherit hover:text-gray-500"
                  style={{ color: navbarTextColor }}
                  onClick={() => navigate(`/maincategory/${category.category_auto_id}`)}
                  
                >
                  <span className="truncate">{category.category_name}</span>
                </button>

                {enabledropdown &&
                  dropdown === category.category_auto_id &&
                  subCategories[category.category_auto_id] && (
                    <div className="absolute left-0 mt-2 bg-white shadow-md rounded-md w-56 z-50 text-black h-[300px] overflow-y-auto">
                      <ul className=" px-4 py-2 ">
                        {subCategories[category.category_auto_id].map((sub) => (
                          <Link
                            to="/productlist"
                            state={{
                              subcategoryName: sub.sub_category_name,
                              sub_cat_id: sub.sub_category_auto_id,
                            }}
                            className=" no-underline text-inherit "
                          >
                            <li
                              key={sub.sub_category_auto_id}
                              className="  px-3 py-2 cursor-pointer  flex hover:bg-gray-200  items-center"
                            >
                              {(categoryCardNo === 1 ||
                                categoryCardNo === 2) && (
                                <img
                                  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${sub.subcategory_image_app}`}
                                  alt={sub.sub_category_name}
                                  className="w-10 h-10 rounded-md mr-2"
                                />
                              )}

                              {(categoryCardNo === 0 ||
                                categoryCardNo === 2) && (
                                <>{sub.sub_category_name}</>
                              )}
                            </li>
                          </Link>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
            ))}
          </div>

          {/* Search Bar */}
          {showSearchBar && (
            <div className="relative w-64 ">
              <input
                type="text"
                placeholder="Search for products, brands and more"
                className="w-full py-2 px-2 rounded-full text-black border text-sm"
                onFocus={() => setSearchActive(true)}
                onBlur={() => setTimeout(() => setSearchActive(false), 200)}
                value={query}
                onChange={handleInputChange}
              />
              <FiSearch className="absolute right-3 top-3 text-gray-500" />

              {/* Search Dropdown */}

              {showDropdown && suggestions.length > 0 && (
                <ul className="absolute top-full left-0 w-full mt-1 bg-white border rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                  {suggestions.map((item, index) => (
                    <Link
                      to={`/product-detail/${item.product_auto_id}`}
                      className="no-underline text-inherit"
                    >
                      <li
                        key={index}
                        className="flex items-center gap-3 px-1 py-2 hover:bg-gray-100 cursor-pointer text-black"
                        onClick={() => {
                          setQuery(item.product_name);
                          setShowDropdown(false);
                        }}
                      >
                        <img
                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0]?.product_image}`}
                          alt={item.product_name}
                          className="w-10 h-10 object-cover rounded-md border"
                        />
                        <span>{item.product_name}</span>
                      </li>
                    </Link>
                  ))}
                </ul>
              )}
            </div>
          )}

          {/* Icons */}
          <div className="flex space-x-4  " style={{ navbarTextColor }}>
            <IoLocationOutline
              className="text-3xl cursor-pointer hover:text-gray-300"
              onClick={() => setShowModal(true)}
            />
            <RiMoneyRupeeCircleLine
              className="text-3xl cursor-pointer hover:text-gray-300"
              onClick={goToWallet}
            />
            <FiUser
              className="text-2xl cursor-pointer hover:text-gray-300"
              onClick={() =>
                !accessToken
                  ? openModal()
                  : setShowUserDropdown(!showUserDropdown)
              }
            />
            {showUserDropdown && (
              <div 
               ref={userDropdownRef}
              className="absolute right-12 mt-[20px] bg-white text-black shadow-md rounded-md w-36 z-50">
                <ul className="px-2 py-1">
                  <li className="pl-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link
                      to="/dashboard"
                      className="text-inherit no-underline flex items-center gap-2"
                    >
                      <FiUser className="text-xl" />
                      <span>Profile</span>
                    </Link>
                  </li>
                  <li
                    className="pl-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      sessionStorage.removeItem("accessToken");
                      setShowUserDropdown(false);
                      navigate("/");
                      setTimeout(() => window.location.reload(), 100);
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <FiLogOut className="text-xl" />
                      <span>Logout</span>
                    </div>
                  </li>
                </ul>
              </div>
            )}
            <div className="relative cursor-pointer" 
            onClick={goToCart}>
            <FiShoppingCart
              className="text-2xl  hover:text-gray-300"
              style={{ color: themeIconColor }}
            />  
            {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-1 sm:px-1.5 py-0.5 rounded-full">
                  {cartCount}
                </span>
              )}
            </div>

            <div className="relative cursor-pointer" 
              onClick={goToWishlist}>
              <IoHeartOutline
                className="text-2xl hover:text-gray-300"
                style={{ color: themeIconColor }}
              />
              {wishlistCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-1 sm:px-1.5 py-0.5 rounded-full">
                  {wishlistCount}
                </span>
              )}
            </div>



          </div>
        </div>
        {isOpen && <Login isOpen={isOpen} onClose={closeModal} />}
        <PincodeModal showModal={showModal} setShowModal={setShowModal} />
      </nav>
    </div>
  );
};

export default Navbar3;
